// app/src/consent/types.ts
//
// Локальные TS типы для consent. Re-export из api/generated.ts где возможно,
// плюс UI-only типы для banner state.

import type { components } from '@/api/generated';

// Backend schemas (re-exported для удобства)
export type ConsentChoices = components['schemas']['ConsentChoices'];
export type ConsentRecord = components['schemas']['ConsentRecord'];
export type RecordConsentRequest = components['schemas']['RecordConsentRequest'];

export type ConsentSource = 'banner' | 'settings_page' | 'registration' | 'gpc_signal';
// Literal union (не `keyof ConsentChoices`) — TS strict видит keyof object как string|number|symbol
// и ломает template literals в i18n keys типа `t(`categories.${category}.name`)`.
export type ConsentCategory = 'essential' | 'functional' | 'analytics' | 'marketing';

// UI state
export interface BannerState {
  visible: boolean;
  source: 'first_visit' | 'reprompt' | 'manual';
}

// Default choices (всё выкл кроме Essential)
export const DEFAULT_CHOICES: ConsentChoices = {
  essential: true,
  functional: false,
  analytics: false,
  marketing: false,
};

// Accept-all variant
export const ACCEPT_ALL_CHOICES: ConsentChoices = {
  essential: true,
  functional: true,
  analytics: true,
  marketing: true,
};

// Document version — должен совпадать с backend domain.CookiePolicyVersion
export const COOKIE_POLICY_VERSION = '1.0';
